import { render, staticRenderFns } from "./PromotionCard.vue?vue&type=template&id=7093bfb0&scoped=true&"
import script from "./PromotionCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PromotionCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PromotionCard.vue?vue&type=style&index=0&id=7093bfb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7093bfb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7093bfb0')) {
      api.createRecord('7093bfb0', component.options)
    } else {
      api.reload('7093bfb0', component.options)
    }
    module.hot.accept("./PromotionCard.vue?vue&type=template&id=7093bfb0&scoped=true&", function () {
      api.rerender('7093bfb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPromotions/components/PromotionCard.vue"
export default component.exports